<script setup lang="ts">
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { Routes } from '@/const/Routes'
  import { useAuthStore } from '@/stores/auth'
  
  import AppSettings from '@/components/AppSettings.vue'
  import Logo from '@/components/icons/Logo.vue'
  import { KsButton } from '@aschehoug/kloss'

  const { t } = useI18n()
  const auth = useAuthStore()
  const settingsOpen = ref(false)

</script>

<template>
  <header>
    <nav>
      <KsButton
        href="#hoved"
        class="skip-button"
        variant="primary"
      >
        {{ t('app.skipToContent') }}
      </KsButton>
      <div class="left">
        <router-link
          :to="{ name: Routes.Home.name }"
          class="link"
        >
          <Logo class="logo" />
        </router-link>
      </div>

      <div v-if="auth.isAuthenticated" class="action-buttons">
        <KsButton
          class="logout-button"
          variant="border"
          shape="rounded"
          size="large"
          @click="auth.logout"
        >
          {{ t('app.logout') }}
        </KsButton>

        <KsButton
          v-ks-tooltip="t('settings.title')"
          shape="round"
          variant="border"
          icon-left="cog"
          size="large"
          @click="settingsOpen = true"
        />
      </div>
    </nav>
  </header>

  <AppSettings
    v-if="auth.isAuthenticated"
    :open="settingsOpen"
    @close="settingsOpen = false"
  />
</template>

<style lang="scss" scoped>

  .logo {
    fill: var(--color-blue-50);
    width: auto;
    height: 30px;
  }

  header {
    padding: 1em 24px;
    z-index: 0;

    nav {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .ks-button {
        border-color: var(--color-blue-50);
        color: var(--color-blue-50);
      }

      .action-buttons {
        display: flex;
        gap: 1em;
      }
    }
  }

  .link:focus-visible {
    .ks-button {
      @include focus-ring;
    }
  }

  .logout-button {
    @include vgs-media-mobile {
      display: none;
    }
  }

  .skip-button {
    position: absolute;
    left: -100%;
    transition: none;
    z-index: 100;
    color: var(--color-white) !important;
  }

  .skip-button:focus-visible {
    top: 1.6rem;
    left: 1.6rem;
  }
</style>
